<template>
<div>
	<p v-if="insideTable && readonly" style="margin:0" :class="[innerValue == emptyState ?  'title' : '']">{{ innerValue }}</p>
	<bee-autocomplete
		v-else
		v-model="localValue"
		:items="insideTable || readonly ? currencies : items"
		@blur="$emit('blur'); focused = false"
		item-value="id"
		:label="label"
		:rules="rules"
		:insideTable="insideTable || dense"
		:item-text="itemText"
		:hide-details="hideDetails"
		@input="$emit('input', $event)"
		@change="$emit('change', $event)"
		@keydown="$emit('keydown', $event)"
		@keypress="$emit('keypress', $event)"
		@keydown-enter-prevent="$emit('keydown-enter-prevent')"
		@keydown-esc-prevent="$emit('keydown-esc-prevent')"
		@keydown-ctrl-down="$emit('keydown-ctrl-down')"
		:readonly="readonly"
		:empty-state="emptyState"
		:disabled="disabled"
		ref="BeeCurrenciesAutocomplete"
		:filter="customFilter"
		@focus="focused = true"
		context="currency" 
		:action-name="actions.GET"
		>
		<template v-slot:selection="data">
			{{ show ? data.item.symbol : ''}}
		</template>
		<template v-slot:item="data">
			{{
				data.item.id 
				? ( itemText ? data.item[itemText] :  data.item.name + '-' + data.item.symbol )
				: $t('undefined')
			}}
		</template>
	</bee-autocomplete>
</div>
</template>
<script>
import ls from '../../../settings/localStorageExtension'
import actions from "../../../permissions/actions-names.js"
export default {
	name: "BeeCurrenciesAutocomplete",
	props: ["rules", "label", "value", "itemText", 'items', 'insideTable', 'hideDetails', 'dense', 'readonly', 'emptyState', 'itemValue', 'disabled'],
	data: ()=>({focused: false, actions}),
	computed:{
		localValue: {
			get: function() {
				return this.value 
			},
			set: function(value) {
				this.$emit('input', value)
			}
		},
		currencies(){
			return [{ id: null, symbol: `${!this.readonly ? "" : this.emptyState}`, latest_exchange_record: null }, ...this.items]
		},		
		innerValue(){
			return  this.localValue ? (ls.getVisibleSymbolMoney()?(this.items.find(c => c.id == this.localValue).symbol || '') : '') : this.emptyState;
		},
		show(){
			return ls.getVisibleSymbolMoney() ? true : this.focused
		},

		valid: {
			get() { return this.$refs.BeeCurrenciesAutocomplete.valid },
			set(val) { this.$refs.BeeCurrenciesAutocomplete.valid = val }
		},
		hasFocused: {
			get() { return this.$refs.BeeCurrenciesAutocomplete.hasFocused },
			set(val) { this.$refs.BeeCurrenciesAutocomplete.hasFocused = val }
		}
	},
	methods: {
		customFilter (item, queryText, itemText) {
		const filter = itemText ? itemText : item.name + '-' + item.symbol
		const searchText = queryText.toLocaleLowerCase()
		return ( 
			filter.toLocaleLowerCase().indexOf(searchText) > -1 
		) },

		focus() {
			this.$refs.BeeCurrenciesAutocomplete.focus();
		},
		validate() {
			return this.$refs.BeeCurrenciesAutocomplete.validate();
		},
		resetValidation() {
			this.$refs.BeeCurrenciesAutocomplete.resetValidation();
		}
	},

	i18n: {
		messages:{
			ar: {
				'undefined': 'غير مُحدد'
			},
			en: {
				'undefined': 'Undefined'
			},
			es: {
				'undefined': 'Indefinido'
			},
		}
	}
};

</script>
